<template>
  <div>
    <v-alert dense style="cursor: pointer" class="mb-0" @click="Expand">
      <template #prepend>
        <div
          :class="[!$vuetify.breakpoint.mobile ? 'mx-6' : undefined]"
          style="color: #1184bd"
        >
          {{ index + 1 }}.
        </div>
      </template>
      <v-container>
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center" justify="end">
              <v-col cols="12" style="word-break: break-all"> {{ q.questionLabel }} </v-col>
            </v-row>
          </v-col>
          <v-col class="shrink d-flex align-center justify-end">
            <v-btn class="mx-2" icon @click.stop="Expand">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-alert>
    <v-expand-transition>
      <v-card v-show="show" flat class="px-6 py-3" color="#F7F7F7">
        <v-row class="my-3">
          <v-col cols="12">ประเภทคำตอบ: {{ ConvertText(q.conditionType) }}</v-col>
        </v-row>
        <FreetextChart
          v-if="q.conditionType === 'freetext'"
          :question="q"
          :daterange="daterange"
          :modal="modal"
        />
        <FixtextChart
          v-if="q.conditionType === 'fixtext'"
          :question="q"
          :daterange="daterange"
          :modal="modal"
        />
        <NumberChart
          v-if="q.conditionType === 'number'"
          :question="q"
          :daterange="daterange"
          :modal="modal"
        />
        <MultiSelectChart
          v-if="q.conditionType === 'multiselect'"
          :question="q"
          :daterange="daterange"
          :modal="modal"
        />
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import FreetextChart from "./FreetextChart";
import FixtextChart from "./FixtextChart";
import NumberChart from "./NumberChart";
import MultiSelectChart from "./MultiSelectChart.vue";
export default {
  props: ["q", "daterange", "modal", "index"],
  components: { FreetextChart, FixtextChart, NumberChart, MultiSelectChart },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    Expand() {
      this.show = !this.show;
    },
    ConvertText(text) {
      switch (text) {
        case "freetext": {
          return "คำบรรยาย";
        }
        case "fixtext": {
          return "ตัวเลือก";
        }
        case "number": {
          return "ตัวเลข";
        }
        case "multiselect": {
          return "เลือกได้มากกว่า 1 คำตอบ";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>